import PropTypes from 'prop-types';

export default PropTypes.shape({
  content: PropTypes.string
});
